export default __webpack_public_path__ + "static/carvingtools-8f8ab8ed34e4f490d1291a6ec85dc0b2.png";